import React from 'react';
import { Sparkles } from 'lucide-react';
import BlobButton from './BlobButton';

const DiscountBanner = ({ onOpenModal }) => {

  return (
    <section 
      className="py-16 bg-cover bg-center bg-no-repeat relative"
      style={{
        backgroundImage: 'url(https://customer-assets.emergentagent.com/job_77845016-0cff-4a07-b056-0e435a63b242/artifacts/8ihh8baw_CTA%20banner.png)',
      }}
    >
      {/* Overlay for better text readability */}
      <div className="absolute inset-0 bg-black bg-opacity-40"></div>
      
      <div className="container mx-auto px-4 relative z-10">
        <div className="flex flex-col items-center justify-center text-center">
          {/* Content */}
          <div className="max-w-3xl">
            <div className="flex items-center justify-center gap-2 mb-4">
              <Sparkles className="w-6 h-6 text-amber-400" />
              <span className="text-amber-400 font-semibold tracking-wider">LIMITED TIME OFFER</span>
            </div>
            
            <h2 className="text-4xl lg:text-5xl font-bold text-white mb-4">
              Get <span className="text-amber-400">40% OFF</span> on First-Time Orders!
            </h2>
            
            <p className="text-xl text-gray-100 mb-8">
              Launch your publishing journey with our exclusive discount. Save big on all premium services.
            </p>

            {/* Buttons */}
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <BlobButton 
                onClick={() => {
                  if (window.zE) {
                    window.zE('webWidget', 'open');
                  }
                }}
                className="w-full sm:w-auto js-chat"
              >
                Discuss Your Book
              </BlobButton>
              
              <BlobButton 
                onClick={onOpenModal}
                variant="white"
                className="w-full sm:w-auto"
              >
                Claim Your Discount
              </BlobButton>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DiscountBanner;